import { render } from "./PlayIcon.vue?vue&type=template&id=0f7077e5&ts=true"
import script from "./PlayIcon.vue?vue&type=script&lang=ts"
export * from "./PlayIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__